// Authored image render scale (ImageMetadata.scale) — bounds and clamping,
// shared by the Images flyout (slider + field) and the Workshop renderer so
// they can't drift apart.
//
// Values outside the range are clamped on read, so older data authored under
// a wider range behaves as if it were in-bounds without rewriting it; the
// stored number is normalised the next time that image's scale is committed.
export const SCALE_MIN = 0.1;
export const SCALE_MAX = 2;

export function clampScale(n: number): number {
    if (!Number.isFinite(n)) return 1;
    return Math.min(SCALE_MAX, Math.max(SCALE_MIN, n));
}

// Resolve a stored scale (possibly undefined / out-of-range) to the effective
// value: defaults to 1, clamped to the current bounds.
export function effectiveScale(scale: number | undefined): number {
    return clampScale(scale ?? 1);
}
